import { useCallback } from 'react';
import downloadCsv from '@dyl/utils/downloadCsv';
import { useSnackbar } from 'notistack';
import { useTests } from '@dyl/systems/TestsManager';

/** @type {import('@dyl/utils/downloadCsv').CsvColumn[]} */
const Columns = [
    { label: 'Password', key: 'token_id' },
    // Derive type by detecting whether there's a test group ID
    { label: 'Type', key: 'type', serialize(type) {
        return type || 'UNKNOWN';
    } },
    { label: 'Status', key: 'status' },
    { label: 'Candidate BPID', key: 'candidate_bp_no' },
    { label: 'Centre Number', key: 'test_centre_number' },
    { label: 'Candidate Number', key: 'legacy_number' },
    { label: 'Date Generated', key: 'created_at' },
    { label: 'Date Redeemed', key: 'date_of_start' },
    { label: 'Description', key: 'description' },
    { label: 'Test ID', key: 'testDisplayId' },
];

export default function useTokensDownload() {
    const { enqueueSnackbar } = useSnackbar();

    const { tests } = useTests();

    return useCallback(
        /**
         * @param {{
         *  token_id: string
         *  status: 'NOT_REDEEMED' | 'REDEEMED' | 'DISABLED'
         *  date_of_start: null
         *  test_group_id: string | null
         *  type: string
         *  candidate_bp_no: string
         *  test_centre_number: string
         *  legacy_number: string
         *  updated_at: string | null
         *  description: string
         * }[]} tokens
         */
        function downloadTokensCsv(tokens) {
            if (!tests) {
                enqueueSnackbar('Cannot download passwords - test IDs not downloaded.', {
                    variant: 'error'
                });
                throw new Error('Cannot download passwords when test IDs not downloaded.');
            }

            const fileName = `GeneratedPasswords_${new Date().toDateString()}.csv`;

            tokens = tokens.map(token => {
                if (!token.test_group_id) {
                    return { ...token, testDisplayId: '' };
                }

                const test = tests.find(test => test.test_group_id === token.test_group_id);
                const testDisplayId = test?.name;

                if (!test) {
                    console.error(`Could not find test ${token.test_group_id}`);
                }

                return { ...token, testDisplayId };
            });

            const reshapeTokens = [];
            for (const token of tokens) {
                const { sap_candidate_data, ...rest } = token;
                if (Array.isArray(sap_candidate_data) && sap_candidate_data.length > 0) {
                    const { candidate_bp_no = null, test_centre_number = null, legacy_number = null } = sap_candidate_data[0];
                    rest.candidate_bp_no = candidate_bp_no;
                    rest.test_centre_number = test_centre_number;
                    rest.legacy_number = legacy_number;
                }
                reshapeTokens.push(rest)
            }
            downloadCsv(fileName, Columns, reshapeTokens);
        }, [tests]
    );
}